<app-entity-page
[closeClicked]="closeClicked"
[switchToMapTab]="switchToMapTab"
[detailsContentTitle]="getDetailsTitle()"
[mapContentTitle]="getMapTitle()"
[loading]="surveyDetailsIsLoading">
  <ng-template #detailsContent>
    <div class="survey-content">
      <div class="survey-content-body">
        <survey-details 
          class="survey-details" 
          [selectedSurvey]="selectedSurveyDetails" 
          [currentLanguage]="currentLanguage$"
          [selectedEntityId]="selectedEntityId"
          (highlightShape)="highlightShape($event.entityId, $event.entityType)">
        </survey-details>
      </div>
    </div>
  </ng-template>
  
  <ng-template #mapContent>
    <div class="survey-map">
      <app-arcgis-map 
        [shapes]="shapes" 
        [mapControls]="mapControls" 
        [extentAll]="true" 
        [popupEnabled]="true" 
        [lang]="currentLang"
        [selectedEntityId]="selectedEntityId">
      </app-arcgis-map>
    </div>
  </ng-template>

  <ng-template #footer>
    <div class="info-container" style="border-bottom:none">
      <div class="info-items-container">
        <div class="info-title">{{'iaa.app.survey.additionalInformation' | translate }}</div>
        <div class="item-container">
          <img class="link-icon" src="assets/surveys-icon.svg" alt="" role="presentation" />
          <a class="info-item" 
             role="button" 
             [class.disabled]="!hasSurveyPolygon()"
             [attr.tabindex]="hasSurveyPolygon() ? 0 : -1"
             [attr.aria-label]="'iaa.app.survey.surveysInArea' | translate"
             [attr.aria-disabled]="!hasSurveyPolygon()"
             (click)="hasSurveyPolygon() && goToSurveys()"
             (keydown.enter)="hasSurveyPolygon() && goToSurveys()"
             (keydown.space)="hasSurveyPolygon() && goToSurveys(); $event.preventDefault()">{{'iaa.app.survey.surveysInArea' | translate}}</a>
        </div>
        <div class="item-container">
          <img class="link-icon" src="assets/excavations-icon.svg" alt="" role="presentation" />
          <a class="info-item" 
             role="button" 
             [class.disabled]="!hasSurveyPolygon()"
             [attr.tabindex]="hasSurveyPolygon() ? 0 : -1"
             [attr.aria-label]="'iaa.app.survey.excavationsInArea' | translate"
             [attr.aria-disabled]="!hasSurveyPolygon()"
             (click)="hasSurveyPolygon() && goToExcavations()"
             (keydown.enter)="hasSurveyPolygon() && goToExcavations()"
             (keydown.space)="hasSurveyPolygon() && goToExcavations(); $event.preventDefault()">{{'iaa.app.survey.excavationsInArea' | translate}}</a>
        </div>
        <div class="item-container">
          <img class="link-icon" src="assets/sites-icon.svg" alt="" role="presentation" />
          <a class="info-item" 
             role="button" 
             [class.disabled]="!hasSurveyPolygon()"
             [attr.tabindex]="hasSurveyPolygon() ? 0 : -1"
             [attr.aria-label]="'iaa.app.survey.sites' | translate"
             [attr.aria-disabled]="!hasSurveyPolygon()"
             (click)="hasSurveyPolygon() && goToSites()"
             (keydown.enter)="hasSurveyPolygon() && goToSites()"
             (keydown.space)="hasSurveyPolygon() && goToSites(); $event.preventDefault()">{{'iaa.app.survey.sites' | translate}}</a>
        </div>
      </div>
    </div>
  </ng-template>
</app-entity-page>
